export const heroSliders = [
  {
    id: 0,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/92746b430a872a8f813ccbd45197adec.jpeg",
    title: "Snekmax Halı",
    description: "Kalite ve zarafetin buluştuğu nokta",
    collection: "all",
    duration: 8000
  },
  {
    id: 1,
    type: "video",
    video: "https://vimeo.com/1161912371",
    thumbnail: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/859221c29a4561befe35b454fec013db.jpeg",
    title: "Snekmax Halı",
    description: "Kalite ve zarafetin buluştuğu nokta",
    collection: "all",
    duration: 10000
  },
  {
    id: 2,
    type: "video",
    video: "https://vimeo.com/1160256763",
    thumbnail: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/0c0473709d7c9273598824c294d6f6fe.jpeg",
    title: "Koleksiyonlarımız",
    description: "Zarafet ve lüksün buluştuğu eşsiz tasarımlar",
    collection: "all",
    duration: 9000
  },
  {
    id: 3,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/6ea4eed980d88c69bf7998e56ae0d1db.jpeg",
    title: "Üretim Sürecimiz",
    description: "Kalite ve mükemmelliğin her adımda buluştuğu üretim",
    collection: "all",
    duration: 8000
  },
  {
    id: 4,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/e184d6ba330519018f4da1aa4f814417.jpeg",
    title: "Bella Koleksiyonu",
    description: "Zarafet ve lüksün buluştuğu eşsiz tasarımlar",
    collection: "bella",
    duration: 8000
  },
  {
    id: 5,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/760a43093c5d730822b073de7ac34a1b.jpeg",
    title: "Sensitive Koleksiyonu",
    description: "Hassas dokunuşlar için özel üretim",
    collection: "sensitive",
    duration: 8000
  },
  {
    id: 6,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/b832a0e7f7e0b42cec5ccad97a3684b4.jpeg",
    title: "Craft Koleksiyonu",
    description: "El sanatlarının modern yorumu",
    collection: "craft",
    duration: 8000
  },
  {
    id: 7,
    type: "image",
    image: "https://readdy.ai/api/search-image?query=opulent%20luxury%20carpet%20collection%20display%20multiple%20exquisite%20handwoven%20carpets%20with%20intricate%20patterns%20premium%20silk%20and%20wool%20materials%20elegant%20showroom%20setting%20sophisticated%20interior%20design%20golden%20accents%20ornate%20details%20high%20end%20product%20photography%20luxurious%20atmosphere%20professional%20lighting%20expensive%20exclusive%20carpet%20collection&width=1920&height=1080&seq=slider007&orientation=landscape",
    title: "Lüks Koleksiyonlar",
    description: "Özel tasarım, sınırlı üretim halılar",
    collection: "luxury",
    duration: 8000
  },
  {
    id: 8,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/f3633c8defb2d63d8569ff6bfa2fd5f4.jpeg",
    title: "Olympus Koleksiyonu",
    description: "Tanrıların halısı, evinizde",
    collection: "olympus",
    duration: 8000
  },
  {
    id: 9,
    type: "image",
    image: "https://static.readdy.ai/image/7acb4d34a19b89cf1afe0d3b45198a24/d6e127236e678f29562edce7f6698c37.jpeg",
    title: "Pashmina Koleksiyonu",
    description: "İpek yumuşaklığında konfor",
    collection: "pashmina",
    duration: 8000
  }
];

export const sliders = heroSliders;

export const interactivePoints = [
  { id: 1, x: 15, y: 20, color: "red", info: "Premium Yün Dokuma" },
  { id: 2, x: 85, y: 25, color: "green", info: "Anti-Alerjik Özellik" },
  { id: 3, x: 25, y: 45, color: "red", info: "Yüksek Yoğunluklu İplik" },
  { id: 4, x: 70, y: 50, color: "green", info: "Leke Tutmaz Yüzey" },
  { id: 5, x: 40, y: 65, color: "red", info: "UV Koruma" },
  { id: 6, x: 60, y: 70, color: "green", info: "Kolay Temizlenir" },
  { id: 7, x: 20, y: 80, color: "red", info: "5 Yıl Garanti" },
  { id: 8, x: 80, y: 75, color: "green", info: "ISO 9001 Sertifikalı" },
  { id: 9, x: 50, y: 35, color: "red", info: "El Dokuması Kalitesi" },
  { id: 10, x: 35, y: 90, color: "green", info: "Çevre Dostu Üretim" }
];